import { render, staticRenderFns } from "./DuplicateArchiver.vue?vue&type=template&id=05554d1a"
import script from "./DuplicateArchiver.vue?vue&type=script&lang=js"
export * from "./DuplicateArchiver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports